import { prettifyInlineJsonString, sleep } from "@/utils";
import axios from "axios";

async function checkQueueSocketConnectivity(check) {
  console.log(`${check.title} Check Started`);

  let reply = { isPassed: false, details: "Not Working!" };

  let apiUrl = axios.defaults.baseURL;
  let socketProtocol = apiUrl.startsWith("https") ? "wss" : "ws";
  let host = new URL(apiUrl).host;

  const queueSocketUrl = socketProtocol + "://" + host + "/queue-socket/" + Date.now();
  let queueSocket = new WebSocket(queueSocketUrl);

  let isOpened = false;
  let isErrored = false;
  let isClosed = false;
  let isReceived = false;
  let isTimedOut = false;

  await Promise.race([
    new Promise((resolve) => {
      queueSocket.onerror = function (event) {
        isErrored = true;
        reply.details = prettifyInlineJsonString(JSON.stringify(event));
        console.error(event);
        resolve();
      };

      queueSocket.onclose = function (e) {
        isClosed = true;
        console.log("WebSocket closed:", e);
        // Delay resolve briefly so onmessage can fire first
        setTimeout(() => {
          if (!isReceived) {
            reply.details = `WebSocket closed: ${prettifyInlineJsonString(e.data)}`;
          }
          resolve();
        }, 200);
      };

      queueSocket.onopen = async function () {
        isOpened = true;

        await sleep(100);
        queueSocket.send(JSON.stringify({ MessageType: 0 }));
      };

      queueSocket.onmessage = function (event) {
        isReceived = true;
        reply.details = `Received: ${prettifyInlineJsonString(event.data)}`;
        console.log("Received WebSocket message from queue server", event.data);
        queueSocket.close();
        resolve();
      };
    }),
    new Promise((resolve) => setTimeout(() => {
      isTimedOut = true;
      resolve();
    }, 10000)),
  ]);

  if (isTimedOut) {
    try { queueSocket.close(); } catch (_) {}
    reply.details = `Error: Connection timed out after 10 seconds.`;
    reply.isPassed = false;
    reply.details = `${check.title}: ${reply.details}`;
    return reply;
  }

  if (isErrored) {
    reply.details = `Error: ${reply.details}`;
    reply.isPassed = false;
    queueSocket.close();
    return reply;
  }

  if (!isReceived && isOpened) {
    reply.details = `Error: WebSocket opened but no response received.`;
    reply.isPassed = false;
  }

  if (isOpened && isReceived && !isErrored) {
    reply.isPassed = true;
    reply.details = "Working properly.";
  }

  reply.details = `${check.title}: ${reply.details}`;
  return reply;
}

export default checkQueueSocketConnectivity;
